var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopifyNoProduct(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 73,
    cy: 73,
    r: 73,
    fill: "#61E5E9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10160_80869",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 126,
    height: 126
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.9998,
    cy: 73,
    r: 62.3689,
    fill: "#73E5FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10160_80869)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 72.9998,
    cy: 73,
    r: 62.3689,
    fill: "#39E4B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.608 106.72L106.312 43.2878L36.8555 102.822L83.6322 151.37H150.608V106.72Z",
    fill: "#5B9698"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5506 40.4529L51.74 39.0354L106.313 43.2878L98.1623 44.7053L92.4924 46.8315L39.6914 42.5791L48.5506 40.4529Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.147 107.429L90.3652 112.39L98.1614 100.696L109.147 107.429Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.147 107.429L90.3652 112.39L98.1614 100.696L109.147 107.429Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.148 107.429L106.313 43.2878L98.1621 44.7053V100.696L109.148 107.429Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.148 107.429L106.313 43.2878L98.1621 44.7053V100.696L109.148 107.429Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1614 44.7053V100.696L90.3652 112.39L92.4914 46.8315L98.1614 44.7053Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1614 44.7053V100.696L90.3652 112.39L92.4914 46.8315L98.1614 44.7053Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8555 102.822L39.6904 42.5791L92.4914 46.8315L90.3652 112.39L36.8555 102.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1045 33.9905C64.0543 36.4867 64.2568 39.7168 64.8193 41.967C64.9617 42.5366 64.6154 43.1138 64.0458 43.2562C63.4762 43.3986 62.899 43.0523 62.7566 42.4827C62.1701 40.1367 61.8757 36.6434 62.9547 33.653C61.3865 34.5406 60.1151 35.8135 59.0913 37.2276C56.7517 40.4589 55.8169 44.2715 55.6172 45.2685C55.2984 46.8604 55.4993 47.9711 55.7769 48.6375C55.918 48.9761 56.0741 49.1897 56.1825 49.3009C56.1966 49.3154 56.209 49.3272 56.2195 49.3366C56.6971 49.4409 57.0548 49.8663 57.0548 50.3753C57.0548 50.9624 56.5788 51.4384 55.9917 51.4384C55.6681 51.4384 55.3951 51.3238 55.2056 51.2158C55.0042 51.101 54.8214 50.9506 54.6601 50.7852C54.3366 50.4534 54.0423 50.0025 53.8142 49.4552C53.3537 48.3497 53.1415 46.8027 53.5324 44.8509C53.756 43.7345 54.7675 39.5739 57.3691 35.9806C58.6778 34.173 60.4165 32.4708 62.697 31.3931C63.3442 31.0873 64.0296 30.8344 64.7545 30.6437C65.2618 30.101 65.8605 29.6172 66.5625 29.2158C68.2275 28.2638 70.3803 27.828 73.0898 28.0538C75.8896 28.2871 78.0543 29.3801 79.671 31.0246C81.2697 32.6509 82.2837 34.7652 82.9026 36.9874C84.1355 41.4143 83.8689 46.5141 83.2611 49.8571C83.1561 50.4347 82.6026 50.8179 82.025 50.7129C81.4473 50.6078 81.0641 50.0544 81.1692 49.4767C81.7426 46.3229 81.9721 41.5711 80.8544 37.5579C80.298 35.5601 79.4249 33.8073 78.1547 32.5152C76.9025 31.2413 75.2164 30.3646 72.9133 30.1726C71.6225 30.0651 70.5341 30.1318 69.6162 30.3242C70.0917 30.3763 70.5792 30.4515 71.0788 30.5515C74.5872 31.2531 76.6223 32.608 77.3752 34.7013C78.0783 36.6558 77.4994 38.9105 76.8462 40.9461C76.6744 41.4815 76.4945 42.0101 76.3164 42.5333C75.7721 44.1328 75.2445 45.6829 75.0157 47.2277C74.7228 49.2048 74.9607 50.9685 76.2891 52.5184C76.6712 52.9641 76.6196 53.6353 76.1738 54.0174C75.728 54.3995 75.0569 54.3479 74.6748 53.9021C72.8139 51.731 72.5639 49.2689 72.9124 46.9161C73.1724 45.161 73.7898 43.3498 74.348 41.7123C74.5149 41.2228 74.6765 40.7488 74.8216 40.2965C75.496 38.1949 75.8019 36.6091 75.3745 35.4209C74.997 34.3714 73.8865 33.2813 70.6618 32.6364C68.8672 32.2775 67.2971 32.2877 65.92 32.557C65.591 32.9924 65.3219 33.4738 65.1045 33.9905Z",
    fill: "#257FFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopifyNoProduct);
export default __webpack_public_path__ + "static/media/shopify-no-product.f374e719.svg";
export { ForwardRef as ReactComponent };